import React from 'react';
import './LoadingContainer.scss';
import { t } from 'i18next';

type LoadingContainerProps = {
    /** The colour of the loading spinner based on a style eg: "color: #fff" */
    colourStyle?: string;
    /** The colour of the loading spinner based on a css class instead of style */
    colourClass?: string;
    /** The message of the loading spinner when it's loading */
    message?: string;
    /** If the loading spinner should be centered or not */
    centered?: boolean;
    /** If the Loading Container should show a spinner or the children it hides */
    loading: boolean;
    /** The child components that the loading container hides when loading is true */
    children?: React.ReactNode;
};

/** A component that displays a loading spinner when loading is true to wait for api calls */
const LoadingContainer = ({
    colourClass = '',
    colourStyle,
    message = t('loading'),
    children,
    centered,
    loading
}: LoadingContainerProps) => {
    let loaderPanel = null;

    if (loading === true) {
        loaderPanel = (
            <div className='text-center loading-anim'>
                <div
                    style={{ color: colourStyle }}
                    className={`spinner-border ${colourClass}`}
                    role='status'></div>
                <span style={{ marginLeft: '1rem', alignSelf: 'center' }}>
                    {message}
                </span>
            </div>
        );
    } else {
        loaderPanel = children;
    }

    const centerClass = centered ? 'loading-container' : '';

    return <div className={centerClass}>{loaderPanel}</div>;
};

export default LoadingContainer;
